import { render, staticRenderFns } from "./Chargehistory.vue?vue&type=template&id=096ea7bd&scoped=true&"
import script from "./Chargehistory.vue?vue&type=script&lang=js&"
export * from "./Chargehistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ea7bd",
  null
  
)

export default component.exports